import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CreateContentplan',
  data () {
    return {
      isLoading: {
        domains: false,
        keywords: false,
        saving: false
      },
      customDomain: '',
      googleDomain: null,
      showCustomDomain: false,
      step: 1,
      expertMode: false,
      loading: false,
      country: null,
      language: null,
      contentplanId: null,
      countries: require('./_countries.json'),
      languages: require('./_languages.json'),
      showExpand: false,
      showAdvanced: false,
      gscUrlInclude: null,
      gscUrlExclude: null,
      valid: false
    }
  },
  async mounted () {
    await this.loadData()
  },
  computed: {
    ...mapGetters([
      'user',
      'domains'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    domain () {
      return this.googleDomain || this.customDomain
    },
    domainName () {
      return (this.domains || []).find(d => d.domain === this.domain)?.name || this.domain
    }
  },
  methods: {
    ...mapActions([
      'loadDomains',
      'createContentplan',
      'runUpdateStatemachine'
    ]),
    async loadData () {
      this.isLoading.domains = true

      try {
        await this.loadDomains()
      } catch (err) {
        console.log(err)
      }

      this.isLoading.domains = false
    },
    async saveContentPlan () {
      if (!this.domain || !this.country || !this.language) return

      this.isLoading.saving = true

      const contentplan = await this.createContentplan({
        workspaceId: this.workspaceId,
        name: this.domainName,
        domain: this.domain,
        country: this.country,
        language: this.language,
        gscUrlInclude: this.gscUrlInclude,
        gscUrlExclude: this.gscUrlExclude
      })
      this.contentplanId = contentplan.id

      if (this.googleDomain) {
        this.runUpdateStatemachine({
          contentplanId: this.contentplanId
        })
      }
      this.customDomain = null
      this.country = null
      this.language = null
      this.isLoading.saving = false

      this.$router.push({
        name: 'Hubs',
        params: {
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId
        }
      })
    }
  }
}
